import * as React from 'react'
import type {TDashboardDataResponse} from '@kapitalist/contract/endpoints'
import {mkGameId, mkUntrustedGameId, type TGameId} from '@kapitalist/contract/types'
import api from '~/api/endpoints'
import DashboardLayout from '~/layouts/DashboardLayout'
import DashboardUI from '~/pages/Dashboard/stateless'
import {navigateTo} from '~/routing/navigate'
import type {ISignedInRouteComponentProps} from '~/routing/Route/SignedIn'
import {dynamicURLs} from '~/routing/sitemap'

interface IProps extends ISignedInRouteComponentProps {}

interface IState {
  dashboardData: TDashboardDataResponse
}
export default class DashboardPage extends React.Component<IProps, IState> {
  joinGame = (params: {gameId: TGameId}) =>
    navigateTo(dynamicURLs.game.waitingRoom({maybeGameId: params.gameId}))

  receiveDashboardData = (dashboardData: TDashboardDataResponse) => {
    this.setState({dashboardData})
  }

  render() {
    return (
      <DashboardLayout {...this.props}>
        <api.dashboard.getData.PromiseManager
          params={{}}
          pathPieces={{}}
          onSuccess={this.receiveDashboardData}
          then={() => (
            <DashboardUI
              authenticatedPlayer={this.props.authenticatedPlayer}
              dashboardData={this.state.dashboardData}
              joinGame={form =>
                api.preGame.joinGame.execute(
                  {},
                  {maybeGameId: mkUntrustedGameId(form.gameId)}
                )
              }
              joinGameSuccess={fs =>
                this.joinGame({...fs, gameId: mkGameId(fs.gameId)})
              }
              createGame={() => api.preGame.createGame.execute({}, {})}
              createGameSuccess={this.joinGame}
              markGameAsStale={gameId => {
                api.dashboard.markGameAsStale
                  .execute({}, {gameId})
                  .then(this.receiveDashboardData)
                  .catch(e => console.error(`Couldn't mark game as stale:`, e))
              }}
            />
          )}
        />
      </DashboardLayout>
    )
  }
}
